import EventBus from '@/js/util/EventBus'
import modalId from '@/js/util/props/modalId'

export default {
  name: 'ModalButton',
  props: {
    ...modalId,

    tag: {
      type: String,
      default: 'button',
    },
  },

  methods: {
    handleClickEvent() {
      EventBus.$emit('toggle:modal', this.modalId)
    },
  },
  render(createElement) {
    const elementData = {
      staticClass: this.$options.name,
      on: {
        click: this.handleClickEvent,
      },
    }
    return createElement(this.tag, elementData, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/modal/ModalButton.js